import loadable from '@loadable/component';
import { NO_SSR } from 'shared/constants/loadable';

/* istanbul ignore next */
export const NewbuildingBrokerRequestExistsModalLoadable = loadable(
  () =>
    import('@cian/frontend-newbuilding-broker-callback-component').catch(() => ({ RequestExistsModal: () => null })),
  {
    resolveComponent: ({ RequestExistsModal }) => RequestExistsModal,
    ssr: NO_SSR,
  },
);
